import VForm from "@/vuetify_custom/v-form";
import VTable from "@/vuetify_custom/v-table/v3";
import VModel from "@/vuetify_custom/v-modal_v1";
import { commonValidateRule } from "@/libs/rules_utils.js";
import { VBtn } from "vuetify/lib";
import { TEXT_FIELD } from "@/vuetify_custom/v-form/type_name";
import {
  getSellOrderSaveApi,
  getContractDetailApi,
  getThirdPartyMallAvailableStockNumApi,
} from "../services";
import VPopDel from "@/views/business/components/v-pop-del";
import { VSelect } from "vuetify/lib/components";
import NumberField from "@/vuetify_custom/v-form/components/Number_Field.js";

const commonValidateRuleGo = commonValidateRule("必选");
const commonValidateRuleT = commonValidateRule("必填");

function createSellOrderItem() {
  return {
    stock_id: null,
    stock_code: null,
    stock_name: null,
    sell_type: null,
    contract_product_price_info_id: null,
    item_id: null,
    sub_item_id: null,
    price: null,
    tax_rate: null,
    quantity: null,
    amount: null,
  };
}

function createParams(params) {
  return {
    id: params?.id || null,
    contract_id: params?.contract_id || null,
    name: params?.name || null,
    payee_company_name: params?.payee_company_name || null,
    payee_company_id: params?.payee_company_id || null,
    memo: params?.memo || null,
    sell_order_items: params?.sell_order_items || [],
  };
}

export default {
  data() {
    return {
      dis: false,
      submitLoading: false,
      params: createParams({}),
      resellOrder: createSellOrderItem(),
      currentContract: null,
      currentContractDetail: null,
      contractList: [],
      stockAmountHash: {},
    };
  },
  computed: {
    baseInfoFields() {
      const _this = this;
      const d = [(val) => !!val || "必选"];
      const arr = [
        {
          label: "合同号",
          key: "contract_id",
          type: "autocompletes_async_v1",
          "item-value": "id",
          api: _this.$util.api.contract_select_search,
          "item-text": "text_name",
          initList: _this.contractList,
          cols: 12,
          // required: true,
          handle_data: ({ contracts }) => {
            return contracts.map((item) => ({
              ...item,
              text_name: `${item.uid}-${item.name}`,
            }));
          },
          change: (data, target) => {
            this.changeContract(target);
          },
          rules: d,
        },
        {
          label: "供应商名称",
          type: TEXT_FIELD,
          key: "payee_company_name",
          cols: 12,
          inline: true,
          row: true,
          disabled: true,
        },
        {
          label: "名称",
          type: TEXT_FIELD,
          key: "name",
          cols: 12,
          required: true,
          rules: d,
        },
        {
          label: "订单备注",
          type: "text_field",
          key: "memo",
          cols: 12,
        },
        {
          key: "table",
          cols: 12,
        },
      ];
      return arr.filter((item) => !item.hide);
    },
    contarctPricingInfos() {
      if (!this.currentContractDetail) {
        return [];
      }
      return this.currentContractDetail.contract_product_price_infos.map(
        (item) => {
          return {
            ...item,
            stock_code_and_type:
              item.stock_code +
              "(" +
              (item.sell_type === 1 ? "销售" : "赠送") +
              ")",
          };
        }
      );
    },
    table_fields() {
      const _this = this;
      return [
        {
          text: "sku代码",
          align: "center",
          value: "contract_product_price_info_id",
          width: 150,
          render: (_, __) => {
            return (
              <div>
                <VSelect
                  v-model={__.contract_product_price_info_id}
                  items={this.contarctPricingInfos}
                  item-text="stock_code_and_type"
                  item-value="id"
                  on-change={(val) => {
                    console.log("val", val);
                    const item = this.contarctPricingInfos.find(
                      (item) => item.id === val
                    );
                    if (item) {
                      __.stock_id = item.stock_id;
                      __.stock_code = item.stock_code;
                      __.stock_name = item.stock_name;
                      __.sell_type = item.sell_type;
                      __.contract_product_price_info_id = item.id;
                      __.item_id = item.item_id;
                      __.sub_item_id = item.sub_item_id;
                      if (item.sell_type === 1) {
                        __.price = item.price;
                      } else {
                        __.price = 0;
                      }
                      __.tax_rate = item.tax_rate;
                    }
                    this.$forceUpdate();
                  }}
                  required
                  rules={[commonValidateRuleGo]}
                ></VSelect>
              </div>
            );
          },
        },
        {
          text: "sku名称",
          align: "center",
          value: "stock_name",
          width: 150,
        },
        {
          text: "销售类型",
          align: "center",
          value: "contract_id",
          width: 150,
          render: (_, __) => {
            const sellText =
              __?.sell_type === 1 ? "销售" : __?.sell_type === 2 ? "赠送" : "-";
            return <div>{sellText}</div>;
          },
        },
        {
          text: "单价",
          align: "center",
          value: "price",
          width: 150,
        },
        {
          text: "库存",
          align: "center",
          value: "stock_amount",
          width: 150,
          render: (_, __) => {
            return <div>{this.stockAmountHash[__.stock_code] || "-"}</div>;
          },
        },
        {
          text: "数量",
          align: "center",
          value: "quantity",
          width: 150,
          render: (_, __) => {
            return (
              <div>
                <NumberField
                  v-model={__}
                  field={{
                    key: "quantity",
                    change: () => {},
                    rules: [
                      commonValidateRuleT,
                      (val) => {
                        if (!this.stockAmountHash[__.stock_code]) {
                          return "未获取到库存信息";
                        }
                        if (
                          Number(val) >
                          Math.max(this.stockAmountHash[__.stock_code], 0)
                        ) {
                          return "库存不足";
                        }
                        // 如果所有条目同一货物的数量之和大于库存数量
                        let count = 0;
                        this.params.sell_order_items.forEach((item) => {
                          if (item.stock_code === __.stock_code) {
                            count += Number(item.quantity);
                          }
                        });
                        if (
                          Number(count) >
                          Math.max(this.stockAmountHash[__.stock_code], 0)
                        ) {
                          return "库存不足";
                        }
                        return true;
                      },
                    ],
                  }}
                />
              </div>
            );
          },
        },
        {
          text: "金额",
          align: "center",
          value: "amount",
          width: 150,
          render: (_, __) => {
            if (!__?.price || !__?.quantity) {
              return <div>-</div>;
            }
            const amount = __?.price * __?.quantity;
            return <div>{amount}</div>;
          },
        },
        {
          text: "操作",
          align: "center",
          width: 120,
          fixed: "right",
          render: (_, __, index) => {
            return (
              <VPopDel
                title="确定删除该条数据？"
                on={{
                  submit: () => {
                    _this.params.sell_order_items.splice(index, 1);
                  },
                }}
              />
            );
          },
        },
      ];
    },
  },
  mounted() {},
  watch: {
    currentContract(newVal) {
      if (newVal) {
        this.getContractStockPricing();
      }
    },
    contarctPricingInfos: {
      handler(newVal) {
        if (!newVal.length) {
          return;
        }
        const codes = newVal.map((item) => item.stock_code);
        if (codes.length) {
          this.getStockAmount(codes.join(","));
        } else {
          this.$Message.error("合同中没有sku信息");
        }
      },
      deep: true,
      immediate: true,
    },
  },
  methods: {
    edit(params) {
      this.dis = true;
      this.params = createParams(params);
      if (params.id) {
        this.currentContract = {
          id: params.contract_id,
        };
      }
    },
    submit() {
      if (
        !(
          this.$refs.base &&
          this.$refs.base.validate &&
          this.$refs.base.validate()
        )
      ) {
        return;
      }
      this.submitLoading = true;
      const { sell_order_items } = this.params;
      const newSellOrderItems = sell_order_items.map((item) => {
        return {
          ...item,
          amount: this.calcAmount(item),
        };
      });
      const params = {
        ...this.params,
        sell_order_items: newSellOrderItems,
      };
      if (!this.params.id) {
        delete params.id;
      }
      getSellOrderSaveApi(params)
        .then(() => {
          this.dis = false;
          this.$emit("success");
          this.$Message.success("保存成功！");
        })
        .finally(() => {
          this.submitLoading = false;
        });
    },
    close() {
      this.dis = false;
      this.$emit("close");
    },
    changeContract(target) {
      console.log("changeContract", target);
      if (!target) {
        this.currentContract = null;
        return;
      }
      if (!this.contractList.some((contract) => contract.id === target.id)) {
        this.contractList.push(target);
      }
      this.currentContract = target;
      this.params.contract_id = target.id;
      this.params.contract_company_id = target.company_id;
      this.params.payee_company_name = target.payee_company;
      this.params.payee_company_id = target.payee_company_id;
    },
    addItem() {
      this.params.sell_order_items.push(createSellOrderItem());
    },
    getContractStockPricing() {
      if (!this.currentContract) {
        this.currentContractDetail = null;
        return;
      }
      getContractDetailApi({ id: this.currentContract.id }).then((res) => {
        this.currentContractDetail = res.contract;
      });
    },
    getStockAmount(codes) {
      getThirdPartyMallAvailableStockNumApi({ stock_codes: codes }).then(
        (res) => {
          console.log("res", res);
          if (Array.isArray(res)) {
            res.forEach((item) => {
              this.stockAmountHash[item.sku_code] = item.available_stock_num;
            });
            this.$forceUpdate();
          }
        }
      );
    },
    calcAmount(item) {
      if (!item?.price || !item?.quantity) {
        return 0;
      }
      return item.price * item.quantity;
    },
  },
  render() {
    return (
      <VModel
        fullscreen
        v-model={this.dis}
        persistent
        dynamic-height
        height-rate={0.7}
        title={this.params.id ? "编辑" : "新建"}
        loading={this.submitLoading}
        on={{
          ok: this.submit,
          cancel: this.close,
        }}
      >
        <VForm
          ref="base"
          v-model={this.params}
          fields={this.baseInfoFields}
          scopedSlots={{
            table: () => {
              return (
                <div>
                  <div>
                    <VBtn on-click={this.addItem}>添加</VBtn>
                  </div>
                  <VTable
                    headers={[...this.table_fields]}
                    desserts={this.params.sell_order_items}
                  />
                </div>
              );
            },
          }}
        />
      </VModel>
    );
  },
};
